import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation, registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { OSCE } from '../db/osce.js';
import {
  archiveOSCEResolver,
  copyOsceByIDResolver,
  deleteOSCEResolver,
  getOSCEsByTypeResolver,
  getPublicOSCEsResolver,
  subscribeAllOscesResolver,
  subscribeOscesByFilterResolver,
} from '../server/resolver.js';

export const getOSCEsByType = registerQuery({
  operationName: 'getOSCEsByType',
  resolve: getOSCEsByTypeResolver,
  type: () => [OSCE],
  params: [{ name: 'osceType', type: () => String }],
});

export const archiveOSCE = registerMutation({
  operationName: 'archiveOSCE',
  resolve: archiveOSCEResolver,
  type: () => Boolean,
  params: [{ name: 'osceID', type: () => String }],
});

export const getPublicOSCEs = registerQuery({
  operationName: 'getPublicOSCEs',
  resolve: getPublicOSCEsResolver,
  type: () => [OSCE],
  params: [{ name: 'osceIDs', type: () => [String] }],
});

export const deleteOSCE = registerMutation({
  operationName: 'deleteOSCE',
  resolve: deleteOSCEResolver,
  type: () => Boolean,
  params: [{ name: 'osceID', type: () => String }],
});

export const copyOsceByID = registerMutation({
  operationName: 'copyOsceByID',
  resolve: copyOsceByIDResolver,
  type: () => String,
  params: [{ name: 'osceID', type: () => String }],
});

export const subscribeAllOsces = registerSubscription({
  operationName: 'subscribeAllOsces',
  resolve: subscribeAllOscesResolver,
  type: () => [OSCE],
  params: [
    { name: 'examType', type: () => String },
    { name: 'includeArchived', type: () => Boolean },
  ],
});

export const subscribeOscesByFilter = registerSubscription({
  operationName: 'subscribeOscesByFilter',
  resolve: subscribeOscesByFilterResolver,
  type: () => [OSCE],
  params: [
    { name: 'skip', type: () => Int },
    { name: 'limit', type: () => Int },
    { name: 'filter', type: () => AdornisFilter },
  ],
});
